import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { useAppContext, useAppStaticContext } from './AppContext';
import { Container } from './Container';
import { HeaderContentType } from './contentTypes';
import logoGolbet from './images/logo/goldbet.svg';
import logoLottomatica from './images/logo/lottomatica.svg';
import logoLottomaticaServizi from './images/logo/lottomaticaservizi.svg';
import logoPlanetwin365 from './images/logo/planetwin365.svg';

export interface HeaderProps {}

export const Header = (props: HeaderProps) => {
  const headerContent = b2x.useContent<HeaderContentType>('HEADER_CONTENT');
  const { brand, getBrandVariant, mock, reverseProxy } = useAppContext();
  const { setMock } = useAppStaticContext();

  return (
    <div
      className={classnames(
        getBrandVariant({
          goldbet: 'bg-brand-primary',
          lottomatica: 'bg-white',
          lottomaticaservizi: 'bg-primary',
          planetwin365: 'bg-primary',
        })
      )}
    >
      <Container>
        <div className="hstack justify-content-between py-2" style={{ minHeight: '50px' }}>
          <div>
            <b2x.router.Link
              silent
              to={getBrandVariant({
                goldbet: 'https://www.goldbet.it/',
                lottomatica: 'https://www.lottomatica.it/',
                lottomaticaservizi: 'https://www.lottomaticaservizi.com',
                planetwin365: 'https://www.planetwin365.it/',
              })}
            >
              {getBrandVariant({
                goldbet: <b2x.Image alt="GoldBet" height={24} src={logoGolbet} />,
                lottomatica: <b2x.Image alt="Lottomatica" height={16} src={logoLottomatica} />,
                lottomaticaservizi: <b2x.Image alt="Lottomatica Servizi" height={28} src={logoLottomaticaServizi} />,
                planetwin365: <b2x.Image alt="PlanetWin365" height={36} src={logoPlanetwin365} />,
              })}
            </b2x.router.Link>
          </div>
          <div className="hstack gap-2 d-none d-lg-flex">
            {headerContent?.body.ctas?.map((cta) =>
              cta.brand === brand ? <b2x.CtaFromContent key={cta.contentSectionId} {...cta.cta} /> : null
            )}
            {!reverseProxy && (
              <>
                <b2x.Button
                  className="d-none d-lg-block"
                  label="Dimentica il brand"
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={() => {
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    window.location.href = b2x.env.PUBLIC_URL === '' ? '/' : b2x.env.PUBLIC_URL;
                  }}
                />
                <b2x.Button
                  label={`Use mock data: ${mock ? 'Yes' : 'No'}`}
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={() => {
                    setMock((prevState) => !prevState);
                  }}
                />
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};
